import { NafThemeType } from '@naf/theme';
import { themeJustSuper, themeLight, themeVisualBreak } from '@lib/nafTheme';
import { SectionBlockType } from '@appTypes/CategoryAppType';
import { ThemeVariants } from '@appTypes/themes';

const THEME_BY_VARIANT: Record<ThemeVariants, NafThemeType> = {
  [ThemeVariants.Standard]: themeLight,
  [ThemeVariants.VisualBreak]: themeVisualBreak,
  [ThemeVariants.JustSuper]: themeJustSuper,
};

// A list, not "any block with a colorScheme": scrollableTextBlocksWithBackgroundImages carries
// the field too but has never been themed by it.
const SELF_THEMED_BLOCKS: ReadonlySet<SectionBlockType['type']> = new Set(['timeline']);

const colorSchemeOf = (block: SectionBlockType): string | undefined =>
  'colorScheme' in block ? (block as { colorScheme?: string }).colorScheme : undefined;

// hasOwn: a CMS string must not resolve to an Object.prototype member.
const isThemeVariant = (value: string | undefined): value is ThemeVariants =>
  value !== undefined && Object.hasOwn(THEME_BY_VARIANT, value);

export const mapBlockTheme = (block?: SectionBlockType, theme?: NafThemeType): NafThemeType => {
  if (block && SELF_THEMED_BLOCKS.has(block.type)) {
    const variant = colorSchemeOf(block);
    return isThemeVariant(variant) ? THEME_BY_VARIANT[variant] : themeLight;
  }
  return theme || themeLight;
};
